class lmiPredominantCtrl {
  $onInit() {
    this.calcIsModal = this.calculatorOptions && this.calculatorOptions.isModal;
  }
}

export default lmiPredominantCtrl;
